import { render, staticRenderFns } from "./AreaDrawEditor.vue?vue&type=template&id=b2b926a2&scoped=true&"
import script from "./AreaDrawEditor.vue?vue&type=script&lang=ts&"
export * from "./AreaDrawEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AreaDrawEditor.vue?vue&type=style&index=0&id=b2b926a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b926a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon})
